module.exports = __webpack_public_path__ + "img/full6-min.1376a3e2.png";